import React, { useEffect } from "react";
import useLostCustomers from "./store";
import { Placeholder } from "react-bootstrap";
import secureLocalStorage from "react-secure-storage";

function EngageCustomer() {
  const { engageCustomerData, fetchEngageCustomerData } = useLostCustomers();

  const loadingValue = Array.from({ length: 6 }).map((_, i) => (
    <td key={i} className="flex-1">
      <Placeholder animation="wave" className="py-3 pe-4">
        <Placeholder bg="primary" xs={12} />
      </Placeholder>
    </td>
  ));
  const medId = secureLocalStorage.getItem("id");
  const agentId = secureLocalStorage.getItem("agentId");

  const userId =
    agentId !== "undefined" && agentId !== "null" && agentId ? agentId : medId;

  useEffect(() => {
    fetchEngageCustomerData(userId);
  }, [userId]);

  const header = [
    "Last Engaged Time",
    "Active",
    "1 Call",
    "2 Calls",
    "2+Call",
    "SLOT",
    "IVR",
  ];

  const timeLabels = [
    "Today",
    "Yesterday",
    "2 days ago",
    "Last week",
    "Last month",
  ];

  const engageData = engageCustomerData
    ? engageCustomerData?.map((item) => {
        return (
          <>
            <td className="flex-1 p-3 py-2 text-primary fw-bold text-center">
              {item?.active}
            </td>
            <td className="flex-1 p-3 py-2 text-primary fw-bold text-center">
              {item?.ivrCall}
            </td>
            <td className="flex-1 p-3 py-2 text-primary fw-bold text-center">
              {item?.slotCall}
            </td>
            <td className="flex-1 p-3 py-2 text-primary fw-bold text-center">
              {item?._1call}
            </td>
            <td className="flex-1 p-3 py-2 text-primary fw-bold text-center">
              {item?._2call}
            </td>
            <td className="flex-1 p-3 py-2 text-primary fw-bold text-center">
              {item?._3call}
            </td>
          </>
        );
      })
    : [];
  return (
    <>
      <table className="d-flex flex-column m-2">
        <thead
          className="d-flex text-gray border-primary border-2 border p-2 mb-2 rounded"
          style={{ backgroundColor: "rgb(234,240,252)" }}
        >
          <tr className="flex-1 d-flex justify-content-between ">
            {header?.map((column, index) => (
              <th className="flex-1 text-center" key={index}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="d-flex flex-column">
          {timeLabels?.map((label, index) => (
            <tr
              id="table-row-value"
              className="flex-1 rounded my-1  d-flex justify-content-between "
              key={index}
            >
              <td
                style={{ background: "rgba(44, 123, 229, .1)" }}
                className="flex-1 p-3 py-2 text-secondary text-center"
              >
                {label}
              </td>
              {engageData[index] || loadingValue}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
export default EngageCustomer;
